/*
  MASX — upsell del carrito por talla.
  Reemplaza la lista fija de productos del cajón del carrito por complementos
  que SÍ tienen stock en la talla que el cliente lleva en el carrito.

  Reglas:
  - Nunca ofrece un tipo de prenda que ya lleva en el carrito.
  - Nunca ofrece un producto sin stock en su talla (se filtra en el servidor).
  - Respeta la temporada (primavera-verano: sep–mar / otoño-invierno: abr–ago).
  - Si no hay nada en su talla, cae a productos sin talla (cinturones, accesorios).

  En escritorio (>=1025px) el panel va AL LADO del cajón: el tema solo le pone la
  clase .open (la que lo hace visible) si al renderizar la sección ya venían
  productos en el HTML. Acá los productos se inyectan por JS, así que el panel
  quedaba invisible; besideSync() lo abre y lo cierra junto con el cajón.

  Todo lo configurable está en CFG, acá arriba.
*/
(function () {
  'use strict';

  var CFG = {
    titulo: 'Todo en tu talla',
    max: 3,

    col: {
      polera: 'polera',
      camisa: 'camisas',
      poleron: 'polerones',
      abrigo: 'parkas-y-camisas',
      boxer: 'boxer',
      short: 'short',
      bermuda: 'bermuda-elasticado',
      pantalon: 'pantalon',
      jeans: 'jeans',
      cinturon: 'cinturones',
      accesorio: 'accesorios'
    },

    numero: {
      XL: ['48', '50'],
      '2XL': ['52'],
      '3XL': ['54', '56'],
      '4XL': ['58', '60'],
      '5XL': ['62', '64'],
      '6XL': ['66', '68'],
      '7XL': ['70']
    },

    plan: {
      polera: ['boxer', 'short', 'bermuda', 'pantalon', 'jeans', 'cinturon'],
      camisa: ['boxer', 'pantalon', 'jeans', 'short', 'bermuda', 'cinturon'],
      poleron: ['boxer', 'pantalon', 'jeans', 'polera', 'cinturon'],
      abrigo: ['boxer', 'pantalon', 'jeans', 'poleron', 'cinturon'],
      boxer: ['polera', 'camisa', 'pantalon', 'jeans', 'cinturon'],
      pantalon: ['polera', 'camisa', 'boxer', 'cinturon'],
      jeans: ['polera', 'camisa', 'boxer', 'cinturon'],
      short: ['polera', 'boxer', 'cinturon'],
      bermuda: ['polera', 'boxer', 'cinturon'],
      cinturon: ['polera', 'camisa', 'pantalon', 'jeans', 'boxer'],
      otro: ['polera', 'boxer', 'pantalon', 'cinturon']
    },

    fueraDeTemporada: {
      verano: ['abrigo', 'poleron'],
      invierno: ['short', 'bermuda']
    },

    sinTalla: ['cinturon', 'accesorio'],
    respaldo: ['cinturon', 'accesorio']
  };

  var LETRA_DE_NUMERO = {};
  Object.keys(CFG.numero).forEach(function (l) {
    CFG.numero[l].forEach(function (n) {
      LETRA_DE_NUMERO[n] = l;
    });
  });

  var CAT_NUMERICA = ['jeans'];
  var CAT_MIXTA = ['pantalon', 'short'];

  var cache = {};
  var trabajando = false;

  function esNumero(t) {
    return /^\d+$/.test(t || '');
  }

  function esVerano() {
    var m = new Date().getMonth() + 1;
    return m >= 9 || m <= 3;
  }

  function tipoDePrenda(titulo) {
    var t = (titulo || '').toLowerCase();
    if (/b[oó]xer|boxer|calzoncillo/.test(t)) return 'boxer';
    if (/pijama/.test(t)) return 'otro';
    if (/cintur[oó]n|correa/.test(t)) return 'cinturon';
    if (/polera|polo|piqu[eé]/.test(t)) return 'polera';
    if (/camisa|guayabera|le[nñ]adora/.test(t)) return 'camisa';
    if (/poler[oó]n|hoodie|canguro/.test(t)) return 'poleron';
    if (/parka|casaca|chaqueta|sweater|cardigan|polar|blazer/.test(t)) return 'abrigo';
    if (/jeans/.test(t)) return 'jeans';
    if (/bermuda/.test(t)) return 'bermuda';
    if (/short/.test(t)) return 'short';
    if (/pantal[oó]n|jogger|buzo/.test(t)) return 'pantalon';
    return 'otro';
  }

  function tallaDeItem(item) {
    var ops = item.options_with_values || [];
    for (var i = 0; i < ops.length; i++) {
      if (/talla|size/i.test(ops[i].name || '')) return String(ops[i].value || '').trim();
    }
    if (item.variant_options && item.variant_options.length) {
      return String(item.variant_options[0] || '').trim();
    }
    return '';
  }

  function tallasObjetivo(cat, talla) {
    if (CFG.sinTalla.indexOf(cat) >= 0) return [null];
    if (!talla) return [null];

    if (esNumero(talla)) {
      var letra = LETRA_DE_NUMERO[talla];
      if (CAT_NUMERICA.indexOf(cat) >= 0) return [talla];
      if (CAT_MIXTA.indexOf(cat) >= 0) return letra ? [talla, letra] : [talla];
      return letra ? [letra] : [];
    }

    var nums = CFG.numero[talla] || [];
    if (CAT_NUMERICA.indexOf(cat) >= 0) return nums;
    if (CAT_MIXTA.indexOf(cat) >= 0) return [talla].concat(nums);
    return [talla];
  }

  function pedir(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tag = doc.querySelector('script[data-masx-upsell]');
        if (!tag) return [];
        try {
          return JSON.parse(tag.textContent.trim()) || [];
        } catch (e) {
          return [];
        }
      })
      .catch(function () {
        return [];
      });
    return cache[url];
  }

  function urlColeccion(handle, talla) {
    var u = '/collections/' + handle + '?filter.v.availability=1';
    if (talla) u += '&filter.v.option.talla=' + encodeURIComponent(talla);
    return u + '&section_id=masx-upsell';
  }

  function variantePara(prod, talla) {
    var vs = prod.variants || [];
    var i;
    if (talla) {
      for (i = 0; i < vs.length; i++) {
        if (vs[i].available && String(vs[i].option1 || '').trim() === talla) return vs[i];
      }
      return null;
    }
    for (i = 0; i < vs.length; i++) {
      if (vs[i].available) return vs[i];
    }
    return null;
  }

  function nombreCorto(titulo) {
    var t = (titulo || '').split('|')[0];
    t = t.replace(/\s*[-–]\s*(tallas?\s+grandes?|talla\s+grande)\s*$/i, '');
    t = t.replace(/\s+hombre\s+talla\s+grande/i, '');
    return t.trim();
  }

  // Formato chileno: $29.990 (Shopify.formatMoney devuelve $29,990 con este money_format)
  function plata(cent) {
    var n = Math.round(cent / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function estilos() {
    if (document.getElementById('masx-upsell-css')) return;
    var s = document.createElement('style');
    s.id = 'masx-upsell-css';
    s.textContent = [
      '.masx-up{display:flex;gap:12px;align-items:center;padding:10px 0;border-bottom:1px solid rgba(0,0,0,.08)}',
      '.masx-up:last-child{border-bottom:0}',
      '.masx-up__img{flex:0 0 64px;width:64px;height:80px;overflow:hidden;border-radius:6px;background:#f4f4f4;display:block}',
      '.masx-up__img img{width:100%;height:100%;object-fit:cover;display:block}',
      '.masx-up__info{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}',
      '.masx-up__title{font-size:13px;line-height:1.3;color:inherit;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.masx-up__talla{font-size:11px;letter-spacing:.02em;opacity:.7}',
      '.masx-up__precio{font-size:13px;font-weight:600}',
      '.masx-up__btn{margin-top:4px;align-self:flex-start;border:1px solid currentColor;background:transparent;color:inherit;border-radius:4px;padding:5px 12px;font-size:12px;cursor:pointer;line-height:1;transition:.2s}',
      '.masx-up__btn:hover{background:#111;color:#fff;border-color:#111}',
      '.masx-up__btn[disabled]{opacity:.5;cursor:default}',
      // En escritorio el panel lateral mide 230px: la tarjeta va vertical, como en el tema.
      '@media (min-width:1025px){',
      '.cart-recommend.beside .masx-up{width:100%;flex-direction:column;align-items:stretch;gap:8px;padding:14px 0}',
      '.cart-recommend.beside .masx-up__img{flex:0 0 auto;width:100%;height:auto;aspect-ratio:4/5}',
      '.cart-recommend.beside .masx-up__info{align-items:center;text-align:center}',
      '.cart-recommend.beside .masx-up__title{font-size:12px}',
      '.cart-recommend.beside .masx-up__btn{align-self:center;margin-top:2px}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  // El panel "al lado" solo se ve en escritorio cuando tiene la clase .open.
  // Debe estar abierto si el cajón está abierto y hay productos que mostrar.
  function besideSync() {
    var cont = document.querySelector('.cart-recommend.beside');
    if (!cont) return;
    var cajon = document.querySelector('.minicart__wrapper');
    var cajonAbierto = !!(cajon && cajon.classList.contains('open'));
    var hayItems = cont.querySelectorAll('.cart-upsell-item').length > 0;
    var debeAbrir = cajonAbierto && hayItems && !cont.classList.contains('hidden');
    var estaAbierto = cont.classList.contains('open');
    if (debeAbrir && !estaAbierto) cont.classList.add('open');
    if (!debeAbrir && estaAbierto) cont.classList.remove('open');
  }

  // Sigue el estado del cajón para abrir/cerrar el panel con él.
  function vigilarCajon() {
    var cajon = document.querySelector('.minicart__wrapper');
    if (!cajon || cajon.masxVigilado) return;
    cajon.masxVigilado = true;
    new MutationObserver(besideSync).observe(cajon, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // El cargador de imágenes del tema no corre sobre el HTML que reemplazamos:
  // sin esto las fotos del carrito quedan en opacity .01 (se ven grises).
  function revelarImagenes(raiz) {
    var cont = raiz || document;
    var pendientes = cont.querySelectorAll('.bls-loading-image');
    Array.prototype.forEach.call(pendientes, function (el) {
      var listo = function () {
        el.classList.remove('bls-loading-image');
        el.classList.add('bls-loaded-image');
      };
      if (el.tagName === 'IMG' && !el.complete) {
        el.addEventListener('load', listo, { once: true });
        el.addEventListener('error', listo, { once: true });
      } else {
        listo();
      }
    });
    var spinners = cont.querySelectorAll('.loading_image');
    Array.prototype.forEach.call(spinners, function (el) {
      el.style.display = 'none';
    });
  }

  function tarjeta(prod, variante, talla) {
    var img = prod.image
      ? '<img src="' + prod.image + '" alt="" loading="lazy" width="64" height="80">'
      : '';
    var etiqueta = talla ? 'Talla ' + talla + ' disponible' : 'Talla única';
    return (
      '<div class="cart-upsell-item masx-up w-full" data-vid="' + variante.id + '">' +
      '<a class="masx-up__img" href="' + prod.url + '?variant=' + variante.id + '">' + img + '</a>' +
      '<div class="masx-up__info">' +
      '<a class="masx-up__title" href="' + prod.url + '?variant=' + variante.id + '">' +
      nombreCorto(prod.title) +
      '</a>' +
      '<span class="masx-up__talla">' + etiqueta + '</span>' +
      '<span class="masx-up__precio">' + plata(variante.price) + '</span>' +
      '<button type="button" class="masx-up__btn" data-masx-add="' + variante.id + '">Agregar</button>' +
      '</div></div>'
    );
  }

  // Talla y tipos de prenda que ya hay en el carrito.
  // La talla se saca de todo el carrito (no del "último" item: Shopify reordena),
  // con preferencia por tallas de letra sobre tallas de número.
  function contextoCarrito(items) {
    var conteo = {};
    var tipos = [];
    items.forEach(function (i) {
      var t = tallaDeItem(i);
      if (t) conteo[t] = (conteo[t] || 0) + (i.quantity || 1);
      var tp = tipoDePrenda(i.product_title || i.title);
      if (tipos.indexOf(tp) < 0) tipos.push(tp);
    });
    var mejor = '';
    var mejorN = -1;
    Object.keys(conteo).forEach(function (t) {
      var n = conteo[t] + (esNumero(t) ? 0 : 0.5);
      if (n > mejorN) {
        mejorN = n;
        mejor = t;
      }
    });
    return { talla: mejor, tipos: tipos };
  }

  function categoriasPermitidas(tipo, tiposEnCarrito) {
    var plan = CFG.plan[tipo] || CFG.plan.otro;
    var fuera = esVerano() ? CFG.fueraDeTemporada.verano : CFG.fueraDeTemporada.invierno;
    var ya = tiposEnCarrito || [];
    return plan.filter(function (c) {
      return fuera.indexOf(c) < 0 && ya.indexOf(c) < 0 && CFG.col[c];
    });
  }

  function buscar(cats, talla, excluir, elegidos) {
    var i = 0;

    function siguiente() {
      if (elegidos.length >= CFG.max || i >= cats.length) return Promise.resolve(elegidos);
      var cat = cats[i++];
      var objetivos = tallasObjetivo(cat, talla);
      if (!objetivos.length) return siguiente();

      var j = 0;

      function probarTalla() {
        if (elegidos.length >= CFG.max || j >= objetivos.length) return siguiente();
        var t = objetivos[j++];
        return pedir(urlColeccion(CFG.col[cat], t)).then(function (prods) {
          for (var k = 0; k < prods.length; k++) {
            var p = prods[k];
            if (excluir.indexOf(p.id) >= 0) continue;
            var v = variantePara(p, t);
            if (!v) continue;
            excluir.push(p.id);
            elegidos.push({ prod: p, variante: v, talla: t });
            return siguiente();
          }
          return probarTalla();
        });
      }

      return probarTalla();
    }

    return siguiente();
  }

  function pintar(cont, wrap, elegidos, talla) {
    estilos();

    if (!elegidos.length) {
      cont.classList.add('hidden');
      cont.classList.remove('open');
      wrap.innerHTML = '';
      return;
    }
    cont.classList.remove('hidden', 'hidden-recommend');
    cont.classList.add('block');

    var h = cont.querySelector('.minicart-heading');
    if (h) h.textContent = talla ? CFG.titulo + ' ' + talla : CFG.titulo;

    wrap.innerHTML = elegidos
      .map(function (e) {
        return tarjeta(e.prod, e.variante, e.talla);
      })
      .join('');

    vigilarCajon();
    besideSync();
  }

  function construir() {
    if (trabajando) return;
    var cont = document.querySelector('.cart-recommend');
    if (!cont) return;
    var wrap = cont.querySelector('.cart-upsell-wrapper') || cont.querySelector('.swiper-wrapper');
    if (!wrap) return;

    trabajando = true;

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          trabajando = false;
          return null;
        }

        var clave = cart.items
          .map(function (i) {
            return i.variant_id + 'x' + i.quantity;
          })
          .join('-');
        if (wrap.dataset.masxKey === clave) {
          trabajando = false;
          vigilarCajon();
          besideSync();
          return null;
        }
        wrap.dataset.masxKey = clave;

        var ctx = contextoCarrito(cart.items);
        var talla = ctx.talla;
        var tipo = tipoDePrenda(cart.items[0].product_title || cart.items[0].title);
        var excluir = cart.items.map(function (i) {
          return i.product_id;
        });

        var cats = categoriasPermitidas(tipo, ctx.tipos);
        var elegidos = [];

        return buscar(cats, talla, excluir, elegidos)
          .then(function (res) {
            if (res.length >= CFG.max) return res;
            var extra = CFG.respaldo.filter(function (c) {
              return cats.indexOf(c) < 0 && ctx.tipos.indexOf(c) < 0 && CFG.col[c];
            });
            return buscar(extra, null, excluir, res);
          })
          .then(function (res) {
            pintar(cont, wrap, res, talla);
            trabajando = false;
          });
      })
      .catch(function () {
        trabajando = false;
      });
  }

  function refrescarCajon() {
    return fetch('/?section_id=minicart-form', { credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('#minicart-form');
        var actual = document.querySelector('#minicart-form');
        if (nuevo && actual && actual.parentNode) {
          actual.parentNode.replaceChild(nuevo, actual);
          revelarImagenes(nuevo);
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = el.classList.contains('cart-count-drawer')
            ? '(' + cart.item_count + ')'
            : cart.item_count > 100
            ? '~'
            : cart.item_count;
        });
        var tp = document.querySelector('header-total-price');
        if (tp && tp.updateTotal) tp.updateTotal(cart);
        var fs = document.querySelector('free-ship-progress-bar');
        if (fs && fs.init) fs.init(cart.items_subtotal_price);
        setTimeout(function () {
          construir();
          revelarImagenes(document.querySelector('#minicart-form'));
        }, 60);
      });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-masx-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    var txt = btn.textContent;
    btn.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.masxAdd), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        return refrescarCajon();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = txt;
      });
  });

  // Botón de cerrar del panel lateral (el tema no lo conecta con recomendaciones manuales).
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button-close-beside');
    if (!b) return;
    var cont = b.closest('.cart-recommend');
    if (cont) cont.classList.remove('open');
  });

  function arrancar() {
    vigilarCajon();
    construir();
    var pendiente = null;
    var obs = new MutationObserver(function () {
      clearTimeout(pendiente);
      pendiente = setTimeout(function () {
        vigilarCajon();
        construir();
        besideSync();
      }, 200);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
